/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_HeroInputs */

const en_home_hero = /** @type {(inputs: Home_HeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DON'T LET AI COMPANIES GAMBLE WITH OUR FUTURE`)
};

/**
* | output |
* | --- |
* | "DON'T LET AI COMPANIES GAMBLE WITH OUR FUTURE" |
*
* @param {Home_HeroInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_hero = /** @type {((inputs?: Home_HeroInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_HeroInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero(inputs)
});